import styled from 'styled-components'
import { Pagination } from 'rsuite'

export const PaginationFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 12px;

  @media (max-width: 1205px) {
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
  }
`

export const PaginationControls = styled.div`
  display: flex;
  align-items: center;
`

export const PaginationNavButton = styled.button`
  border: none;
  background: none;
  color: var(--primary);
  padding: 0;
  visibility: visible;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:not(:disabled) {
    cursor: pointer;
    opacity: 1;
  }
`

export const PaginationPrevButton = styled(PaginationNavButton)`
  margin-right: 0.5rem;
`

export const PaginationNextButton = styled(PaginationNavButton)`
  margin-left: 0.5rem;
`

export const PaginationChevronIcon = styled.i`
  font-size: 1.2rem;
`

export const StyledPagination = styled(Pagination)`
  --rs-pagination-item-active-bg: var(--primary);
  --rs-pagination-item-active-color: var(--white);
  --rs-pagination-item-active-border-color: var(--primary);
  --rs-pagination-item-hover-bg: var(--white);
  --rs-pagination-item-hover-color: var(--primary);
  --rs-pagination-item-hover-border-color: var(--primary);
  --rs-pagination-item-color: var(--primary);
  --rs-pagination-item-border-color: var(--primary);
  --rs-pagination-item-bg: var(--white);

  && {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    gap: 4px !important;
  }

  .rs-pagination {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    gap: 4px !important;
  }

  .rs-pagination-btn {
    min-width: 32px;
    height: 32px;
    border-radius: 4px;
    border: 1px solid var(--primary);
    color: var(--primary);
    background: var(--white);
  }

  .rs-pagination-btn:hover {
    background: var(--white);
    color: var(--primary);
    border-color: var(--primary);
  }

  .rs-pagination-btn-active {
    background: var(--primary) !important;
    color: var(--white) !important;
    border-color: var(--primary) !important;
  }

  .rs-pagination-btn-disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .rs-pagination-btn-disabled:hover {
    background: var(--white);
    color: var(--primary);
  }
`

export const ItemsPerPageLabel = styled.div`
  color: var(--primary);
  font-size: 0.9rem;
  margin-left: 1rem;
`
